import React from "react";
import globalStyle from '@/styles/Global.scss'
import componentStyle from "@/styles/Component.scss";

const CommercialPanel = () => {
  return (
    <>
      <div className={componentStyle.inputArea}>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            特定商取引に関する法律に基づく表記
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            運営業者
          </div>
          <div className={globalStyle.value}>
            株式会社カード･アンド･メディア
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            運営システム名
          </div>
          <div className={globalStyle.value}>
            名刺R（アール）
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            所在地
          </div>
          <div className={globalStyle.value}>
            〒530-0037　大阪市北区松ヶ枝町6-12　西栄ビル
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            お問合先
          </div>
          <div className={globalStyle.value}>
            <a href={'mailto:sales@cardandmedia.co.jp'}>sales@cardandmedia.co.jp</a>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            ご利用方法
          </div>
          <div className={globalStyle.value}>
            インターネットブラウザ上からご登録ください。 → <a href={'https://meishi-r.com'}>https://meishi-r.com</a>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            ご利用料金
          </div>
          <div className={globalStyle.value}>
            名刺のご登録500円+税、ご登録名刺の使用51名から500円+税/月、受入のみは無料
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            ご利用の有効期限
          </div>
          <div className={globalStyle.value}>
            特に無し
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            お支払い方法
          </div>
          <div className={globalStyle.value}>
            カード決済
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            運営責任者
          </div>
          <div className={globalStyle.value}>
            辻　俊雄
          </div>
        </div>
      </div>
    </>
  )
}
export default CommercialPanel
